import script from "./CheckboxButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckboxButton.vue?vue&type=script&lang=ts&setup=true"

import "./CheckboxButton.vue?vue&type=style&index=0&id=699cf016&lang=scss&scoped=true"

import exportComponent from "C:\\work\\to-create\\bailing\\yc-bailing-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-699cf016"]])

export default __exports__